import { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
    NotificationLevel,
    NotificationLevelTranslations,
    NotificationBorderVariants,
} from '../../../enums';

const NotificationCheckbox = ({ level, isChecked, onChange }) => {
    const borderClass = useMemo(() => NotificationBorderVariants[level], [level]);

    return (
        <div
            className={`mr-2 flex-1 border border-l-4 border-notification-border ${borderClass} bg-white py-2 pl-1 pr-3`}
        >
            <div className="flex items-center">
                <input
                    className="mx-2.5"
                    type="checkbox"
                    id={`notification-checkbox-${level}`}
                    name={`level-${level}`}
                    value={level}
                    checked={isChecked ? 'checked' : ''}
                    onChange={onChange}
                    aria-label={interpolate(
                        gettext('NOTIFICATION_LEVEL_CHECKBOX'),
                        { level },
                        true
                    )}
                />
                <label htmlFor={`notification-checkbox-${level}`}>
                    {NotificationLevelTranslations[level]}
                </label>
            </div>
        </div>
    );
};

NotificationCheckbox.propTypes = {
    level: PropTypes.oneOf(Object.values(NotificationLevel)).isRequired,
    isChecked: PropTypes.bool.isRequired,
    onChange: PropTypes.func,
};

export default NotificationCheckbox;
